import { 
  INSTAGRAM_INFO_SET, 
  INSTAGRAM_INFO_UNSET 
} from "state/types/UserTypes";
import { ExecuteRequestOnUrl } from "core/glambox/GlamboxApi";

export const InstagramInfoFetch = (username) => {
  return (dispatch) => {
    console.log("https://www.instagram.com/" + username + "/?__a=1");
    ExecuteRequestOnUrl(
      "https://www.instagram.com/" + username + "/?__a=1",
      null,
      "GET",
      null,
      null,
      (response) => {
        const {
          result,
          statusCode
        } = response;
        
        if (!result) return null;

        if (result.graphql && result.graphql.user) {
          dispatch(InstagramInfoSet(result.graphql.user));
        }
      }
    );
  };
};

// export const InstagramFetchById = (id) => {
//   ExecuteRequestOnUrl(
//     `https://i.instagram.com/api/v1/users/${id}/info/`,
//     null,
//     "GET",
//     {
//       "User-Agent": navigator.userAgent
//     },
//     null,
//     (response) => {
//       const {
//         result,
//         statusCode
//       } = response;

//       console.log(result, statusCode);
//     }
//   );
// };

export const InstagramInfoSet = (info) => {
  return {
    payload: {
      data: info
    }, 
    type: INSTAGRAM_INFO_SET
  };
};

export const InstagramInfoUnset = () => {
  return {
    type: INSTAGRAM_INFO_UNSET
  };
};
